import { RiMoneyDollarCircleFill, RiMoneyDollarCircleLine } from "react-icons/ri";
import { TbMoneybag } from "react-icons/tb";
import { SiMoneygram } from "react-icons/si";
import { GiClothes } from "react-icons/gi";

import Card from '../../components/Card/Card';
import CardHeader from '../../components/Card/CardHeader';
import CardIcon from '../../components/Card/CardIcon.js';
import { EncabezadoContainer } from './reportesComponents';
import { styles } from './reportesComponents';
import { makeStyles } from '@mui/styles';
import { useContext } from 'react';
import { ReportesContext } from '../../context/ReportesContext';

const useStyles = makeStyles(styles);

function EncabezadoReportes() {
  const classes = useStyles();
  const { proveedores, productosVendidos, productosEnStock, totalCredito, totalEfectivo, totalOtros, devCoco, devProveedores, gananciasCoco, gananciasProveedores, totalNotasDeCredito, totalNotasDeCreditoGeneradas } = useContext(ReportesContext);
  return (
    <EncabezadoContainer>
      <Card>
        <CardHeader color='success' stats icon>
          <CardIcon color='success'>
            <TbMoneybag />
          </CardIcon>
          <p className={classes.cardCategory}>Totales</p>
          <h4 className={classes.cardTitle}>Ventas {`$${(totalCredito + totalEfectivo + totalOtros + totalNotasDeCredito + totalNotasDeCreditoGeneradas).toFixed(2)}`}</h4>
          <h4 className={classes.cardTitle}>Credito {`$${(totalCredito).toFixed(2)}`}</h4>
          <h4 className={classes.cardTitle}>Efectivo {`$${(totalEfectivo+totalNotasDeCredito + totalNotasDeCreditoGeneradas).toFixed(2)}`}</h4>
          <h4 className={classes.cardTitle}>Otros {`$${totalOtros.toFixed(2)}`}</h4>
          <h4 className={classes.cardTitle}>Notas de credito consumidas {`$${totalNotasDeCredito.toFixed(2)}`}</h4>
          <h4 className={classes.cardTitle}>Notas de credito generadas {`$${Math.abs(totalNotasDeCreditoGeneradas.toFixed(2))}`}</h4>

        </CardHeader>
      </Card>
      <Card>
        <CardHeader color='warning' stats icon>
          <CardIcon color='warning'>
            <SiMoneygram />
          </CardIcon>
          <p className={classes.cardCategory}>Devoluciones</p>
          <h4 className={classes.cardTitle}>Coco {`$${devCoco.toFixed(2)}`}</h4>
          <h4 className={classes.cardTitle}>Proveedores {`$${devProveedores.toFixed(2)}`}</h4>
        </CardHeader>
      </Card>
      <Card>
        <CardHeader color='info' stats icon>
          <CardIcon color='info'>
            <RiMoneyDollarCircleFill />
          </CardIcon>
          <p className={classes.cardCategory}>Ganancias</p>
          <h4 className={classes.cardTitle}>Co.Co {`$${gananciasCoco.toFixed(2)}`}</h4>

        </CardHeader>
      </Card>
      <Card>
        <CardHeader color='info' stats icon>
          <CardIcon color='info'>
            <RiMoneyDollarCircleLine />

          </CardIcon>
          <p className={classes.cardCategory}>Ganancias </p>
          <h4 className={classes.cardTitle}>Provedoras {`$${gananciasProveedores.toFixed(2)}`}</h4>
        </CardHeader>
      </Card>

      <Card>
        <CardHeader color='danger' stats icon>
          <CardIcon color='danger'>
            <GiClothes />
          </CardIcon>
          <p className={classes.cardCategory}>{`${proveedores}`}</p>
          <h4 className={classes.cardTitle}>Provedor@s registradas</h4>
          <p className={classes.cardCategory}>Producto</p>

          <h4 className={classes.cardTitle}>en stock {productosEnStock}</h4>
          <h4 className={classes.cardTitle}>vendidos {productosVendidos}</h4>
        </CardHeader>
      </Card>
    </EncabezadoContainer>
  );
}

export default EncabezadoReportes;
